<template>
  <input
    ref="inputRef"
    v-maska
    :data-maska="mask"
    data-maska-eager
    v-model="masked"
    class="modal-input"
    type="tel"
    autocomplete="tel"
    :placeholder="placeholder"
    :disabled="disabled"
    @paste="handlePaste"
  />
</template>

<script>
import { vMaska } from 'maska/vue'

export default {
  name: 'PhoneInput',

  directives: { maska: vMaska },

  props: {
    modelValue: {
      type: String,
      default: ''
    },
    disabled: Boolean,
    placeholder: {
      type: String,
      default: '+7 900 000-00-00'
    }
  },

  emits: ['update:modelValue', 'valid'],

  data() {
    return {
      masked: '+7 '
    }
  },

  computed: {
    mask() {
      return '+7 ### ###-##-##'
    }
  },

  watch: {
    modelValue: {
      immediate: true,
      handler(newVal) {
        // Если родитель передал нормализованный номер — преобразуем в маску
        if (newVal && newVal !== this.getRaw()) {
          const digits = newVal.replace(/\D/g, '')
          this.masked = this.formatMasked(digits)
        }
      }
    },

    masked(val) {
      const digits = val.replace(/\D/g, '')
      const normalized = digits.length === 11 ? `+${digits}` : ''
      this.$emit('update:modelValue', normalized)
      this.$emit('valid', digits.length === 11)
    }
  },

  methods: {
    formatMasked(digits) {
      if (!digits) return '+7 '
      digits = digits.replace(/^8/, '7') // 8 → 7
      if (!digits.startsWith('7')) digits = '7' + digits
      digits = digits.slice(0, 11)
      const rest = digits.slice(1)
      let formatted = '+7'
      if (rest) formatted += ' ' + rest.slice(0, 3)
      if (rest.length > 3) formatted += ' ' + rest.slice(3, 6)
      if (rest.length > 6) formatted += ' ' + rest.slice(6, 8)
      if (rest.length > 8) formatted += ' ' + rest.slice(8, 10)
      return formatted
    },

    getRaw() {
      return this.masked.replace(/\D/g, '')
    },

    handlePaste(e) {
      e.preventDefault()
      const text = (e.clipboardData || window.clipboardData).getData('text')
      const digits = text.replace(/\D/g, '')

      let normalizedDigits = digits
      if (normalizedDigits.startsWith('8')) {
        normalizedDigits = '7' + normalizedDigits.slice(1)
      }
      if (normalizedDigits.length === 10 && normalizedDigits.startsWith('9')) {
        normalizedDigits = '7' + normalizedDigits
      }

      normalizedDigits = normalizedDigits.slice(0, 11)
      this.masked = this.formatMasked(normalizedDigits)
    },

    focus() {
      this.$refs.inputRef?.focus()
    }
  },

  mounted() {
    // Если ничего не передали — показываем +7 с пробелом
    if (!this.modelValue) {
      this.masked = '+7 '
    }
    this.$nextTick(() => {
      const len = this.masked.length
      this.$refs.inputRef?.setSelectionRange(len, len)
    })
  }
}
</script>